const layout = () => import("../../internal/dashboard/layoutV2.vue");
const enterprise = () => import("./infoEnterpriseV2.vue");

const enterpriseRoutes = {
  component: layout,
  children: [
    {
      path: "/enterprise",
      name: "enterprise",
      meta: {
        title: "enterprise",
        requiresAuth: true,
      },
      component: enterprise,
    },
  ],
  
};

export default enterpriseRoutes;